<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center px-4">
    <!-- Icon or Vector -->
    <div class="mb-6 ">
      <svg class="w-24 h-24 text-warning-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#0a58a9">
        <path d="M10 2a8 8 0 100 16 8 8 0 000-16zM9 8h2v5H9V8zm1 8a1 1 0 110-2 1 1 0 010 2z" />
      </svg>
    </div>

    <!-- Text Heading -->
    <h1 class="text-3xl font-bold text-gray-700 mb-4 " style="color: #0a58a9;">Welcome to the Donor Registration</h1>

    <!-- Subtext -->
    <p class="text-lg text-gray-600 mb-6 text-center" style="color: #e59a75;">
      Please select your facility to proceed. Access to the system is only available via registered facilities.
    </p>

    <!-- Facility Dropdown -->
    <div class="mb-6 w-full max-w-xs">
      <label for="facility" class="block text-left text-gray-700 font-medium mb-1" style="color: #0a58a9;">Select Facility:</label>
      <div class="relative">
        <select
          v-model="selectedFacility"
          id="facility"
          class="w-full p-3 border border-gray-300 rounded bg-white text-gray-700 shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
         
        >
          <option disabled value="" >Select a facility</option>
          <!-- Ensure correct value property here -->
          <option v-for="facility in facilities" :key="facility.facility_id" :value="facility.facility_id">
            {{ facility.name }}
          </option>
        </select>
        <!-- Dropdown Icon -->
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 bg-custom-yellow">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>
      </div>
    </div>

    <!-- Start Button -->
    <button
      @click="openNewDonor"
      :disabled="!selectedFacility"
      class="bg-custom-yellow text-white font-semibold px-6 py-3 rounded-md shadow-md hover:bg-custom-yellow transition disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Start New Donor Registration
    </button>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import apiClient from '../services/api.js'; // Import your getFacilities service

export default {
  name: 'DonorRegistration',
  setup() {
    const router = useRouter();
    const facilities = ref([]);
    const selectedFacility = ref('');

    // Fetch facilities on component mount
    onMounted(async () => {
      try {
        const response = await apiClient.getFacilities();
        facilities.value = response; 
      } catch (error) {
        console.error('Error fetching facilities:', error);
      }
    });

    const openNewDonor = () => {
      if (selectedFacility.value) {
        router.push({ name: 'NewDonor', params: { facilityId: selectedFacility.value } });
      }
    };

    const logSelectedFacility = () => {
      console.log("Selected Facility: ", selectedFacility.value); // Log the selected facility ID
    };

    return {
      facilities,
      selectedFacility,
      openNewDonor,
      logSelectedFacility
    };
  }
};
</script>

<style scoped>
.bg-custom-yellow {
  background-color: #0a58a9;
}
</style>
